import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { debounceTime } from 'rxjs';
import { ITabelaEngates } from './listagem-engates-model';
import { EngateDesengateService } from 'src/app/services/EngateDesengateService/engateDesengate.service';
import { formatarData } from 'src/app/core/utils/utilities';
import { IGetEngatesOrDesengatesParams } from 'src/app/services/EngateDesengateService/engateDesengate.model';
import { IGetReportBase64 } from 'src/app/services/ReportService/report.model';
import { AppExportBase64 } from 'src/app/services/ExportBase64/exportBase64.service';
import { ImpressoraService } from 'src/app/services/ImpressoraService/impressora.service';

@Component({
  selector: 'app-listagem-engates',
  templateUrl: './listagem-engates.component.html',
  styleUrls: ['./listagem-engates.component.scss']
})
export class ListagemEngatesComponent {
  form = this.initForm();
  tableData: ITabelaEngates[] | Array<any> = [];
  paginaAtual: number = 1;
  maxPages: number = 1;
  expandirCardsMobile: boolean = true;
  isLoading: boolean = false;

  tableColumns = [
    { header: 'Código', key: 'idEngate', type: 'text' },
    { header: 'Nº do Agendamento', key: 'agendamento', type: 'text' },
    { header: 'Empresa', key: 'empresa', type: 'text' },
    { header: 'Data Entrada', key: 'dataEntrada', type: 'text' },
    { header: 'Data Engate', key: 'dataEngate', type: 'text' },
    { header: 'Placa Engate', key: 'placaEngate', type: 'text' },
    { header: 'Motorista', key: 'motorista', type: 'text' },
    {
      header: 'Ações',
      key: 'actions',
      type: 'buttons',
      buttons: [
        {
          label: 'Visualizar',
          img: 'assets/eye-icon.png',
          action: (item: any) => this.visualizarEngate(item)
        },
        {
          label: 'Download Ticket',
          img: 'assets/icon-download.svg',
          action: (item: any) => this.downloadTicket(Number(item.idEngate))
        },
        {
          label: 'Impressão Ticket',
          img: 'assets/icon-print.svg',
          action: (item: any) => this.imprimirTicket(Number(item.idEngate))
        }
      ]
    }
  ];

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private engateDesengateService: EngateDesengateService,
    private appExportBase64: AppExportBase64,
    private impressoraService: ImpressoraService
  ) {}

  ngOnInit() {
    this.getEngates();
  }

  initForm() {
    const form = this.fb.group({
      FK_AGND: [null],
      NM_EPSA: [null],
      NM_MTRT: [null],
      TX_PLCA_CAVA: [null],
      DT_INIC: [null],
      DT_FIM: [null],
      NU_STTS: [null]
    });
    return form;
  }

  ngAfterViewInit(): void {
    this.form.valueChanges.pipe(debounceTime(300)).subscribe(() => {
      this.getEngates();
    });
  }

  navegarNovoEngate() {
    this.router.navigate(['cadastro/engate']);
  }

  mudarPagina(pagina: number) {
    this.paginaAtual = pagina + 1;
    this.getEngates();
  }

  getEngates(): void {
    this.isLoading = true;
    const params = this.createParams();
    this.engateDesengateService.GetEngateOrDesengates(params).subscribe({
      next: res => {
        const data = res.ITEMS;
        this.tableData = data.map(item => {
          const placas = [];

          if (item.TX_PLCA_CRRT1 !== null) placas.push(item.TX_PLCA_CRRT1);
          if (item.TX_PLCA_CRRT2 !== null) placas.push(item.TX_PLCA_CRRT2);
          if (item.TX_PLCA_CRRT3 !== null) placas.push(item.TX_PLCA_CRRT3);

          const placasEngate = placas.join(' | ');

          return {
            idEngate: item.PK_ENGT_DSGT,
            agendamento: item.FK_AGND,
            dataEntrada: formatarData(item.DT_GATE_ENTR),
            dataEngate: formatarData(item.DT_ENGT_DSGT),
            placaEngate: placasEngate,
            motorista: item.NM_MTRT,
            empresa: item.NM_EPSA ?? '---'
          };
        });
        this.maxPages = res.TOTAL_PAGES;
        this.isLoading = false;
      },
      error: (err: any) => {
        this.isLoading = false;
      }
    });
  }

  createParams(): IGetEngatesOrDesengatesParams {
    return {
      FL_ENGT: true,
      PAGE_NUMBER: this.paginaAtual,
      PAGE_SIZE: 8,
      NM_EPSA: this.form.get('NM_EPSA')?.value,
      NM_MTRT: this.form.get('NM_MTRT')?.value,
      TX_PLCA_CAVA: this.form.get('TX_PLCA_CAVA')?.value,
      DT_INIC: this.form.get('DT_INIC')?.value,
      DT_FIM: this.form.get('DT_FIM')?.value,
      NU_STTS: this.form.get('NU_STTS')?.value,
      FK_AGND: this.form.get('FK_AGND')?.value
    };
  }

  visualizarEngate(item: any) {
    const queryParams = {
      ...item,
      isViewing: true
    };
    this.router.navigate(['cadastro/engate'], {
      queryParams: queryParams
    });
  }

  downloadTicket(id: number) {
    this.isLoading = true;

    this.engateDesengateService.GetReceiptEngateById(id, 0).subscribe({
      next: (response: IGetReportBase64) => {
        this.appExportBase64.downloadPDF(response.ReportBase64, 'ticket');
        this.isLoading = false;
      },
      error: _error => {
        this.isLoading = false;
      }
    });
  }

  imprimirTicket(id: number) {
    this.isLoading = true;

    this.engateDesengateService.GetReceiptEngateById(id, 1).subscribe({
      next: (response: IGetReportBase64) => {
        this.isLoading = false;
        this.impressoraService.impressoraTicket(
          response.ReportBase64,
          'text/plain'
        );
      },
      error: _error => {
        this.isLoading = false;
      }
    });
  }
}
